import PropTypes from "prop-types";
import style from "./styles";

const PremierInfoMessage = ({ premierCountrySelector }) => (
  <div className={style.PremierInfoMessage}>
    <h2>
      <span className={style.PremierInfoIcon} aria-hidden="true">
        i
      </span>
      <span className={style.infoMessageTitle}>
        {premierCountrySelector.infoMessageTitle}
      </span>
    </h2>
    <p>{premierCountrySelector.infoMessageDescription}</p>
  </div>
);

PremierInfoMessage.propTypes = {
  premierCountrySelector: PropTypes.shape({
    infoMessageTitle: PropTypes.string.isRequired,
    infoMessageDescription: PropTypes.string.isRequired,
  }),
};

export default PremierInfoMessage;
